import React, { Component } from 'react'
import { isValidResetPasswordRequest, resetPassword } from '../../services/User';
import Formsy from 'formsy-react'
import { Grid} from 'semantic-ui-react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox'
import fieldPasswordIcon from '../../assets/images/newui/field-password-icon.png'
import servicegrace from '../../assets/images/newui/servicegrace.svg'
import next from '../../assets/images/newui/sellersignup/next-btn.svg'
import '../SignInContainer/SignInContainerNew.less'
import GeneralMessage from '../../components/GeneralMessage/GeneralMessage';


const initialState = {
    isLoading: false,
    password: '',
    confirmPassword: '',
    windowWidth: 0,
    isValidated: false,
    isValidRequest: false,
    message: '',
    messageType: 'error'
}
class PasswordResetContainerNew extends Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    }

    async componentDidMount() {
        
        const hash = this.props.passwordResetHash || this.props.match.params.passwordResetHash;
        const response = await isValidResetPasswordRequest(hash);
        response.data = response.data || { isValid: false };
        await this.setState({
            isValidated: true,
            isValidRequest: response.data.isValid || false,
            message: !response.data.isValid && (response.message || 'Request is not valid or expired.') || '',
            messageType: 'error'
        })
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        
    }

    handleChange = (e, { name, value }) => {
        this.setState({ [name]: value });
    }

    redirectToAppStore = () => {
        window.open('http://itunes.apple.com/app/id1481417514', '_blank');
    }

    redirectToDashboard = () => {
        this.props.history.push('/');
    }

    onValidSubmit = async () => {
        try {
            const hash = this.props.passwordResetHash || this.props.match.params.passwordResetHash;
            const { password, confirmPassword } = this.state;
            this.setState({ isLoading: true });
            const response = await resetPassword(hash, { password, confirmPassword });
            if (response.resStatus >= 400) {
                this.setState({
                    message: response.message || 'Password reset failed, try again later.',
                    messageType: 'error'
                })
            } else {
                if(this.props.redirectToDashboard) {
                    setTimeout(() => {
                        this.redirectToDashboard();
                    }, 2000);
                }
            
                this.setState({
                    message: this.props.isSetPassowrd ? "Password set successfully. Redirecting..." : response.message || 'Password reset successfully.',
                    messageType: 'success'
                })
            }
        } catch (error) {

        } finally {
            this.setState({ isLoading: false });
        }
    };
    redirectToSignIn = () => {
        this.props.history.push('/signin');
    }
    render() {
        const { isValidated, isValidRequest, message, messageType } = this.state

        return (
            <React.Fragment>
           

            <div className='small-form-container'>
                <img src={servicegrace} />
                <div className='small-form-heading'>ServiceGrace</div>
                <div className='small-form-sub-heading'>{this.props.heading || "Reset Your Password"}</div>
                {!_.isEmpty(this.state.message) && <GeneralMessage message={this.state.message} type={this.state.messageType} />}
                <Formsy onValidSubmit={this.onValidSubmit} className='small-form-form'>
                    <Grid>
                    <Grid.Column width={16} >
                                            <DGTextbox name="password" label="Password" placeholder="" required type="password"
                                                tabIndex={4}
                                                icon={fieldPasswordIcon}
                                                maxLength={50}
                                                disabled={!isValidRequest}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',


                                                }}
                                                onChange={this.handleChange}
                                            />


                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <DGTextbox name="confirmPassword" label="Confirm Password" placeholder="" required type="password"
                                                tabIndex={4}
                                                icon={fieldPasswordIcon}
                                                maxLength={50}
                                                disabled={!isValidRequest}
                                                validations={{
                                                    equalsField: 'password'
                                                }}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'This field is required',
                                                    equalsField: 'Both passwords must match.'

                                                }}
                                                onChange={this.handleChange}
                                            />


                                        </Grid.Column>


                        
                        
                        <button className='small-form-submit' tabIndex={6} type='submit' disabled={!this.state.isValidRequest}>GO <img src={next} /></button>

                    </Grid>
                </Formsy>
            </div>

</React.Fragment>
        )
    }
}

function mapStateToProps({ buyer }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        buyerFormData: buyer

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({

        
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordResetContainerNew));
